<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Merchant contract detail</h1>
    </div>
    <!-- <b-breadcrumb :items="[
      {
        text: 'Home',
        href: '/'
      }, {
        text: 'Merchant owner',
        href: '#'
      }
    ]" /> -->

    <b-card>
      <template #header>
        <ul class="report-preview">
          <li>
            <div class="label">Liên hệ</div>
            <div class="value">{{ (info && info.collapse && info.collapse.contacts) || 0 }}</div>
          </li>
          <li>
            <div class="label">Thiết bị</div>
            <div class="value">
              {{ (info && info.collapse && info.collapse.deviceStores) || 0 }}
            </div>
          </li>
          <li>
            <div class="label">Nhân viên</div>
            <div class="value">{{ (info && info.collapse && info.collapse.storeStaffs) || 0 }}</div>
          </li>
        </ul>
      </template>

      <b-row class="gx-2">
        <b-col cols="12" md="6">
          <div class="form-detail">
            <h1>Thông tin chung</h1>
            <template v-if="!isLoading">
              <div v-for="key in Object.keys(info)" :key="key">
                <div v-if="typeof info[key] !== 'object'" class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label">
                    {{ key }} <span class="float-right">:</span>
                  </label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ info[key] }}</p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="form-detail">
            <h1>Hợp đồng</h1>
            <template v-if="!isLoading">
              <ListContract :list="info.contracts || []" />
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>

          <div class="form-detail">
            <h1>Danh sách điểm bán</h1>
            <template v-if="!isLoading">
              <ListStore :list="info.stores || []" />
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Detail } from '@/services/customer-support/contract'
  import { showMess } from '@/config/utils'
  import ListContract from './components/ListContract'
  import ListStore from './components/ListStore'
  import ListContact from './components/ListContact'
  import { info } from 'sass'

  export default {
    components: {
      ListContract,
      ListStore,
    },
    data() {
      return {
        isLoading: false,
        isLoadingContract: false,
        id: '',
        info: {},
      }
    },

    filters: {},

    created() {
      this.id = this.$router.currentRoute.params.id
    },

    mounted() {
      this.loadData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .breadcrumb {
    margin-bottom: 0;
  }
  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul.report-preview {
    padding-left: 0;
    display: flex;
    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }
      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }
      & + li {
        margin-left: 10px;
      }
    }
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }
</style>
